var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-container",
        { staticClass: "pa-0", attrs: { "grid-list-xs": "", fluid: "" } },
        [
          _vm.form.parameters.hasOwnProperty(_vm.parameters_names.job_title)
            ? _c(
                "v-layout",
                { attrs: { row: "", wrap: "" } },
                [
                  _c("v-text-field", {
                    staticClass: "dense_input",
                    attrs: { outline: "" },
                    on: {
                      change: function($event) {
                        return _vm.emitChange()
                      }
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "label",
                          fn: function() {
                            return [
                              _vm._v("\n\t\t\t\t\tJob Title\n\t\t\t\t\t"),
                              _vm.parameters[_vm.parameters_names.job_title]
                                .required
                                ? _c("span", { staticClass: "ml-1" }, [
                                    _vm._v("\n\t\t\t\t\t\t*\n\t\t\t\t\t")
                                  ])
                                : _vm._e()
                            ]
                          },
                          proxy: true
                        }
                      ],
                      null,
                      false,
                      2557073913
                    ),
                    model: {
                      value:
                        _vm.form.parameters[_vm.parameters_names.job_title],
                      callback: function($$v) {
                        _vm.$set(
                          _vm.form.parameters,
                          _vm.parameters_names.job_title,
                          $$v
                        )
                      },
                      expression: "form.parameters[parameters_names.job_title]"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.form.parameters.hasOwnProperty(_vm.parameters_names.output_folder)
            ? _c(
                "v-layout",
                { attrs: { row: "", wrap: "" } },
                [
                  _c("v-text-field", {
                    ref: _vm.parameters_names.output_folder,
                    staticClass: "file-input dense_input",
                    attrs: {
                      outline: "",
                      prefix: _vm.getFileBasename(
                        _vm.form.parameters[_vm.parameters_names.output_folder]
                      ),
                      "append-icon": "folder_open"
                    },
                    on: {
                      change: function($event) {
                        return _vm.pathCleaner(
                          _vm.parameters_names.output_folder
                        )
                      },
                      "click:append": function($event) {
                        return _vm.showFileExplorer(
                          _vm.parameters[_vm.parameters_names.output_folder],
                          null
                        )
                      }
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "label",
                          fn: function() {
                            return [
                              _vm._v("\n\t\t\t\t\tOutput Folder\n\t\t\t\t\t"),
                              _vm.parameters[_vm.parameters_names.output_folder]
                                .required
                                ? _c("span", { staticClass: "ml-1" }, [
                                    _vm._v("\n\t\t\t\t\t\t*\n\t\t\t\t\t")
                                  ])
                                : _vm._e()
                            ]
                          },
                          proxy: true
                        }
                      ],
                      null,
                      false,
                      4091519001
                    ),
                    model: {
                      value:
                        _vm.form.parameters[_vm.parameters_names.output_folder],
                      callback: function($$v) {
                        _vm.$set(
                          _vm.form.parameters,
                          _vm.parameters_names.output_folder,
                          $$v
                        )
                      },
                      expression:
                        "form.parameters[parameters_names.output_folder]"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "v-layout",
            { attrs: { row: "", wrap: "" } },
            [
              _vm.form.parameters.hasOwnProperty(
                _vm.parameters_names.audio_config
              )
                ? _c(
                    "v-flex",
                    { attrs: { shrink: "" } },
                    [
                      _c("v-select", {
                        staticClass: "dense_input",
                        attrs: {
                          outline: "",
                          items:
                            _vm.parameters[_vm.parameters_names.audio_config]
                              .choices,
                          label: "Audio Config"
                        },
                        on: {
                          change: function($event) {
                            return _vm.onAudioConfChange($event)
                          }
                        },
                        model: {
                          value:
                            _vm.form.parameters[
                              _vm.parameters_names.audio_config
                            ],
                          callback: function($$v) {
                            _vm.$set(
                              _vm.form.parameters,
                              _vm.parameters_names.audio_config,
                              $$v
                            )
                          },
                          expression:
                            "form.parameters[parameters_names.audio_config]"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.form.parameters.hasOwnProperty(
                _vm.parameters_names.downmix_output_config
              )
                ? _c(
                    "v-flex",
                    { attrs: { shrink: "" } },
                    [
                      _c("v-select", {
                        staticClass: "dense_input",
                        attrs: {
                          outline: "",
                          items:
                            _vm.parameters[
                              _vm.parameters_names.downmix_output_config
                            ].choices,
                          label: "Downmix Output Config"
                        },
                        on: {
                          change: function($event) {
                            return _vm.emitChange()
                          }
                        },
                        model: {
                          value:
                            _vm.form.parameters[
                              _vm.parameters_names.downmix_output_config
                            ],
                          callback: function($$v) {
                            _vm.$set(
                              _vm.form.parameters,
                              _vm.parameters_names.downmix_output_config,
                              $$v
                            )
                          },
                          expression:
                            "form.parameters[parameters_names.downmix_output_config]"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.form.parameters.hasOwnProperty(
                _vm.parameters_names.upmix_output_config
              )
                ? _c(
                    "v-flex",
                    { attrs: { shrink: "" } },
                    [
                      _c("v-select", {
                        staticClass: "dense_input",
                        attrs: {
                          outline: "",
                          items:
                            _vm.parameters[
                              _vm.parameters_names.upmix_output_config
                            ].choices,
                          label: "Upmix Output Config"
                        },
                        on: {
                          change: function($event) {
                            return _vm.emitChange()
                          }
                        },
                        model: {
                          value:
                            _vm.form.parameters[
                              _vm.parameters_names.upmix_output_config
                            ],
                          callback: function($$v) {
                            _vm.$set(
                              _vm.form.parameters,
                              _vm.parameters_names.upmix_output_config,
                              $$v
                            )
                          },
                          expression:
                            "form.parameters[parameters_names.upmix_output_config]"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.form.parameters.hasOwnProperty(
                _vm.parameters_names.varispeed_config
              )
                ? _c(
                    "v-flex",
                    { attrs: { shrink: "" } },
                    [
                      _c("v-select", {
                        staticClass: "dense_input",
                        attrs: {
                          outline: "",
                          items:
                            _vm.parameters[
                              _vm.parameters_names.varispeed_config
                            ].choices,
                          label: "Varispeed Config"
                        },
                        on: {
                          change: function($event) {
                            return _vm.emitChange()
                          }
                        },
                        model: {
                          value:
                            _vm.form.parameters[
                              _vm.parameters_names.varispeed_config
                            ],
                          callback: function($$v) {
                            _vm.$set(
                              _vm.form.parameters,
                              _vm.parameters_names.varispeed_config,
                              $$v
                            )
                          },
                          expression:
                            "form.parameters[parameters_names.varispeed_config]"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.form.parameters.hasOwnProperty(
                _vm.parameters_names.qt_profile
              )
                ? _c(
                    "v-flex",
                    { attrs: { shrink: "" } },
                    [
                      _c("v-select", {
                        staticClass: "dense_input",
                        attrs: {
                          outline: "",
                          items:
                            _vm.parameters[_vm.parameters_names.qt_profile]
                              .choices,
                          label: "QT Profile"
                        },
                        on: {
                          change: function($event) {
                            return _vm.emitChange()
                          }
                        },
                        model: {
                          value:
                            _vm.form.parameters[
                              _vm.parameters_names.qt_profile
                            ],
                          callback: function($$v) {
                            _vm.$set(
                              _vm.form.parameters,
                              _vm.parameters_names.qt_profile,
                              $$v
                            )
                          },
                          expression:
                            "form.parameters[parameters_names.qt_profile]"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.form.parameters.hasOwnProperty(_vm.parameters_names.fps)
                ? _c(
                    "v-flex",
                    { attrs: { shrink: "" } },
                    [
                      _c("v-select", {
                        staticClass: "dense_input",
                        attrs: {
                          outline: "",
                          items:
                            _vm.parameters[_vm.parameters_names.fps].choices,
                          label: "FPS"
                        },
                        on: {
                          change: function($event) {
                            return _vm.emitChange()
                          }
                        },
                        model: {
                          value: _vm.form.parameters[_vm.parameters_names.fps],
                          callback: function($$v) {
                            _vm.$set(
                              _vm.form.parameters,
                              _vm.parameters_names.fps,
                              $$v
                            )
                          },
                          expression: "form.parameters[parameters_names.fps]"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.form.parameters.hasOwnProperty(
                _vm.parameters_names.measurement_only
              )
                ? _c(
                    "v-flex",
                    { attrs: { grow: "" } },
                    [
                      _c("v-checkbox", {
                        staticClass: "ml-3",
                        attrs: {
                          "hide-details": "",
                          label: "Measurement Only",
                          color: "primary"
                        },
                        on: {
                          change: function($event) {
                            return _vm.emitChange()
                          }
                        },
                        model: {
                          value:
                            _vm.form.parameters[
                              _vm.parameters_names.measurement_only
                            ],
                          callback: function($$v) {
                            _vm.$set(
                              _vm.form.parameters,
                              _vm.parameters_names.measurement_only,
                              $$v
                            )
                          },
                          expression:
                            "form.parameters[parameters_names.measurement_only]"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.form.parameters.hasOwnProperty(_vm.parameters_names.harmonize)
                ? _c(
                    "v-flex",
                    { attrs: { grow: "" } },
                    [
                      _c("v-checkbox", {
                        staticClass: "ml-3",
                        attrs: {
                          "hide-details": "",
                          label: "Harmonize",
                          color: "primary"
                        },
                        on: {
                          change: function($event) {
                            return _vm.emitChange()
                          }
                        },
                        model: {
                          value:
                            _vm.form.parameters[_vm.parameters_names.harmonize],
                          callback: function($$v) {
                            _vm.$set(
                              _vm.form.parameters,
                              _vm.parameters_names.harmonize,
                              $$v
                            )
                          },
                          expression:
                            "form.parameters[parameters_names.harmonize]"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.form.parameters.hasOwnProperty(
                _vm.parameters_names.dialogue_measurement
              )
                ? _c(
                    "v-flex",
                    { attrs: { shrink: "" } },
                    [
                      _c("v-checkbox", {
                        staticClass: "ml-3",
                        attrs: {
                          "hide-details": "",
                          label: "Dialogue Measurement",
                          color: "primary"
                        },
                        on: {
                          change: function($event) {
                            return _vm.emitChange()
                          }
                        },
                        model: {
                          value:
                            _vm.form.parameters[
                              _vm.parameters_names.dialogue_measurement
                            ],
                          callback: function($$v) {
                            _vm.$set(
                              _vm.form.parameters,
                              _vm.parameters_names.dialogue_measurement,
                              $$v
                            )
                          },
                          expression:
                            "form.parameters[parameters_names.dialogue_measurement]"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.form.parameters.hasOwnProperty(
                _vm.parameters_names.r128_measurement
              )
                ? _c(
                    "v-flex",
                    { attrs: { shrink: "" } },
                    [
                      _c("v-checkbox", {
                        staticClass: "ml-3",
                        attrs: {
                          "hide-details": "",
                          label: "R128 Measurement",
                          color: "primary"
                        },
                        on: {
                          change: function($event) {
                            return _vm.emitChange()
                          }
                        },
                        model: {
                          value:
                            _vm.form.parameters[
                              _vm.parameters_names.r128_measurement
                            ],
                          callback: function($$v) {
                            _vm.$set(
                              _vm.form.parameters,
                              _vm.parameters_names.r128_measurement,
                              $$v
                            )
                          },
                          expression:
                            "form.parameters[parameters_names.r128_measurement]"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _vm.form.parameters.hasOwnProperty(_vm.parameters_names.audio_tracks)
            ? _c("v-layout", { attrs: { row: "", wrap: "" } }, [
                _vm.form.parameters[_vm.parameters_names.audio_tracks].length
                  ? _c("table", { attrs: { id: "audio-table" } }, [
                      _c("colgroup", [
                        _c("col", { staticStyle: { width: "40px" } }),
                        _vm._v(" "),
                        _c("col"),
                        _vm._v(" "),
                        _c("col", { staticStyle: { width: "200px" } })
                      ]),
                      _vm._v(" "),
                      _c("thead", [
                        _c("tr", [
                          _c(
                            "td",
                            { staticClass: "text-center" },
                            [
                              _c(
                                "v-btn",
                                {
                                  staticClass: "ma-0",
                                  attrs: {
                                    flat: "",
                                    icon: "",
                                    color: "warning",
                                    disabled: !_vm.form.parameters[
                                      _vm.parameters_names.audio_tracks
                                    ][0].path
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.emptyTracks("all")
                                    }
                                  }
                                },
                                [_c("v-icon", [_vm._v("close")])],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("td", [
                            _c("span", { staticClass: "subheading" }, [
                              _vm._v("Audio Tracks")
                            ])
                          ]),
                          _vm._v(" "),
                          _c(
                            "td",
                            { staticClass: "px-2" },
                            [
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    small: "",
                                    block: "",
                                    color: "success",
                                    disabled: !_vm.form.parameters[
                                      _vm.parameters_names.audio_tracks
                                    ][0].path,
                                    loading: _vm.probing
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.validateTracks()
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t\tValidation\n\t\t\t\t\t\t\t"
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "tbody",
                        _vm._l(
                          _vm.form.parameters[
                            _vm.parameters_names.audio_tracks
                          ],
                          function(track, i) {
                            return _c("tr", { key: "track_" + i }, [
                              _c(
                                "td",
                                { staticClass: "text-center" },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      staticClass: "ma-0",
                                      attrs: {
                                        flat: "",
                                        icon: "",
                                        color: "warning",
                                        disabled: !track.path
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.emptyTracks(i)
                                        }
                                      }
                                    },
                                    [_c("v-icon", [_vm._v("close")])],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "td",
                                [
                                  _c("v-text-field", {
                                    ref: _vm.parameters_names.audio_tracks,
                                    refInFor: true,
                                    staticClass: "file-input dense_input",
                                    attrs: {
                                      readonly: "",
                                      outline: "",
                                      prefix: _vm.getFileBasename(track.path),
                                      "append-icon": "folder_open"
                                    },
                                    on: {
                                      "click:append": function($event) {
                                        return _vm.showFileExplorer(
                                          _vm.parameters[
                                            _vm.parameters_names.audio_tracks
                                          ],
                                          i
                                        )
                                      }
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "label",
                                          fn: function() {
                                            return [
                                              _vm._v(
                                                "\n\t\t\t\t\t\t\t\t\tAudio Tracks\n\t\t\t\t\t\t\t\t\t"
                                              ),
                                              _vm.parameters[
                                                _vm.parameters_names
                                                  .audio_tracks
                                              ].required
                                                ? _c(
                                                    "span",
                                                    { staticClass: "ml-1" },
                                                    [
                                                      _vm._v(
                                                        "\n\t\t\t\t\t\t\t\t\t\t*\n\t\t\t\t\t\t\t\t\t"
                                                      )
                                                    ]
                                                  )
                                                : _vm._e()
                                            ]
                                          },
                                          proxy: true
                                        },
                                        {
                                          key: "prepend",
                                          fn: function() {
                                            return [
                                              _vm.audioconfig_mapping.hasOwnProperty(
                                                _vm.form.parameters[
                                                  _vm.parameters_names
                                                    .audio_config
                                                ]
                                              )
                                                ? _c("span", [
                                                    _vm._v(
                                                      "\n\t\t\t\t\t\t\t\t\t\t" +
                                                        _vm._s(
                                                          _vm
                                                            .audioconfig_mapping[
                                                            _vm.form.parameters[
                                                              _vm
                                                                .parameters_names
                                                                .audio_config
                                                            ]
                                                          ][i]
                                                        ) +
                                                        "\n\t\t\t\t\t\t\t\t\t"
                                                    )
                                                  ])
                                                : _vm._e()
                                            ]
                                          },
                                          proxy: true
                                        }
                                      ],
                                      null,
                                      true
                                    ),
                                    model: {
                                      value: track.path,
                                      callback: function($$v) {
                                        _vm.$set(track, "path", $$v)
                                      },
                                      expression: "track.path"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("td", { staticClass: "pa-1 text-center" }, [
                                track.valid === true
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "success--text text--lighten-1"
                                      },
                                      [
                                        _c("span", {
                                          directives: [
                                            {
                                              name: "safe-html",
                                              rawName: "v-safe-html",
                                              value: track.probe,
                                              expression: "track.probe"
                                            }
                                          ]
                                        })
                                      ]
                                    )
                                  : track.valid === false
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "error--text font-weight-bold"
                                      },
                                      [
                                        _c("span", {
                                          directives: [
                                            {
                                              name: "safe-html",
                                              rawName: "v-safe-html",
                                              value: track.probe,
                                              expression: "track.probe"
                                            }
                                          ]
                                        })
                                      ]
                                    )
                                  : _c(
                                      "div",
                                      {
                                        staticClass: "warning--text subheading"
                                      },
                                      [_vm._v("- - -")]
                                    )
                              ])
                            ])
                          }
                        ),
                        0
                      )
                    ])
                  : _vm._e()
              ])
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _vm.explorer.show
        ? _c("Explorer", {
            attrs: {
              assetType: _vm.explorer.asset_type,
              multiselect: false,
              default_folder: _vm.explorer.default_value,
              return_dir_filelist: _vm.explorer.return_dir_filelist,
              toolbarTitle: "Selectionnez des assets présents sur le filesystem"
            },
            on: {
              close: function($event) {
                return _vm.onExplorerClose()
              },
              selectedAssets: function($event) {
                return _vm.onSelectedAssets($event)
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: {
            "hide-overlay": "",
            persistent: "",
            "max-width": "fit-content"
          },
          model: {
            value: _vm.check_path_loader.active,
            callback: function($$v) {
              _vm.$set(_vm.check_path_loader, "active", $$v)
            },
            expression: "check_path_loader.active"
          }
        },
        [
          _c(
            "v-card",
            { attrs: { color: "primary" } },
            [
              _c(
                "v-card-text",
                { staticClass: "text-center" },
                [
                  _c("span", { staticClass: "color--text headline" }, [
                    _vm._v("\n\t\t\t\t\tCheck Path\n\t\t\t\t")
                  ]),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c("span", { staticClass: "color--text subheading" }, [
                    _vm._v(
                      "\n\t\t\t\t\t" +
                        _vm._s(_vm.check_path_loader.path) +
                        "\n\t\t\t\t"
                    )
                  ]),
                  _vm._v(" "),
                  _c("v-progress-linear", {
                    staticClass: "mb-0",
                    attrs: { indeterminate: "", color: "color" }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ad635d5a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ad635d5a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./build/scramble/app-loader.js!./src/pages/maestro/jobs/launcher/job_launcher_form_audiotools_audiofiles.vue
// module id = null
// module chunks = 